import {THOR_STATUS} from './appsConstants';

export const svcNameMap = {
	[THOR_STATUS.KAIZEN]: 'NO-CCD',
	[THOR_STATUS.THOR]: 'NO-WAM',
	[THOR_STATUS.WAM]: 'WAM'
};

export const ANALYTICS_PAGE_TYPES = {
	CHECKOUT: 'Checkout',
	DOWNLOAD: 'ACom',
	ORGANIC: 'Organic',
	SEO: 'SEO',
	CATALOG: 'CCH',
	EMAIL: 'Email',
	LMS_BLACKBOARD: 'Blackboard',
	LMS_CANVAS: 'Canvas'
};
